import React from 'react';

import SoftwarePanel from '@totem/components/software/software_report/softwarePanel';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const SoftwarePage = () => {
  return (
    <ContentLayout>
      <SoftwarePanel />
    </ContentLayout>
  );
};

export default SoftwarePage;
